module.exports = __webpack_public_path__ + "img/map.6b44786c.svg";